/**
 * The extractors a source can name, for the sources screen's picker.
 *
 * A HAND-KEPT LIST, and it has to be. The registry is
 * `apps/backend/src/modules/catalog/import-extractors.ts`, and `listExtractors()`
 * has no route behind it -- so there is nothing for the admin to derive this
 * from at runtime. The same situation as the column targets in
 * `import-template.ts` and the accept attribute on the imports dashboard, and
 * it is handled the same way: `import-contract.test.ts` reads this file and
 * fails when the server's registry gains a key this list does not offer.
 *
 * That pin runs in ONE direction. A key left here after the server drops it is
 * not caught by the contract test -- it is caught by the server, which refuses
 * an unknown extractor by name at both `POST` and `PATCH /sources`.
 *
 * A picker that omits a registered extractor is the failure worth preventing:
 * the JSON-LD reader was already unreachable once, through a route whose
 * hand-kept mime list had fallen behind this same registry.
 */

export interface ExtractorOption {
	value: string;
	label: string;
	/** What an operator should be uploading if they choose this. */
	hint: string;
}

export const EXTRACTOR_OPTIONS: ExtractorOption[] = [
	{
		value: "csv",
		label: "CSV or spreadsheet export",
		hint: "A price list saved as CSV or XLSX. The usual choice.",
	},
	{
		value: "jsonld",
		label: "Brand product page (schema.org)",
		hint: "A saved brand product page carrying schema.org markup.",
	},
	/*
	 * One entry per SITE, because a page with no structured data can only be
	 * read by rules written against that brand's own markup (plan 013 U4).
	 * A brand missing from this list needs an adapter written, not a generic
	 * option that would read the page wrongly and stage the result.
	 */
	{
		value: "html:parryware",
		label: "Parryware product page",
		hint: "A Parryware product page. Read by rules written against its markup.",
	},
];
